import 'store/updateShowtimes';

import { h } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';
import { track } from 'utils/tracking';
import Page from 'components/pages/page.js';
import GMap from 'components/shared/gmap/gmap.js';
import Maptiler from 'components/shared/maptiler/maptiler.js';
import Selection from 'components/pages/showtimes/selection.js';
import OneSheet from 'components/pages/showtimes/oneSheet.js';
import FakeScrollbar from 'components/shared/fakeScrollbar/fakeScrollbar';
import ClosableTrailer from 'components/shared/closableTrailer/closableTrailer.js';
import s from 'components/pages/showtimes/showtimes.sss';
import Geo from 'models/Geo';
import { accessNested } from 'utils/utils';

export default class Showtimes extends Page {

	/**
	 * Life Cycle
	**/

	constructor(props) {
		super(props);
		let showtimes = props.showtimes;
		this.activeTheater = showtimes.theaters && showtimes.theaters.find(th => th.active);
		this.state.trailerClosed = false;

		if (typeof window !== 'undefined') {
			let store = Store.get();
			let hasGeo = accessNested(store, 'client.geo');
			let previousShowtimesPage = accessNested(store, 'showtimes.loadingPage');
			let isDifferentPage = previousShowtimesPage !== accessNested(store, 'activePage.id');
			let shouldReloadShowtimes = hasGeo && isDifferentPage;
			if (shouldReloadShowtimes) {
				Store.emit(actions.GET_SCREENINGS, null, !previousShowtimesPage);
			}
		}
	}

	componentWillMount() {
		// Check whether closed trailer should be shown
		if (typeof window !== 'undefined') {
			window.firstSessionVisit = typeof window.firstSessionVisit === 'undefined';
		}
	}

	componentDidMount() {
		super.componentDidMount();
		// Make sure defaultFilters are used
		Store.emit(actions.CHECK_FILTERS);
		this.checkGeolocation();
	}

	componentWillUpdate(props) {
		let showtimes = props.showtimes;
		if (showtimes.theaters !== this.props.showtimes.theaters) {
			this.activeTheater = showtimes.theaters && showtimes.theaters.find(th => th.active);
		}
		this.checkGeolocation(props);
	}

	/**
	 * Utils
	**/

	checkGeolocation(props) {
		if (typeof window === 'undefined' || window.geoCheckDone) return;
		props = props || this.props;
		if (!props.client.geo) return;
		window.geoCheckDone = true;

		if (accessNested(props.appData, 'options.useBrowserGeolocation') && 'geolocation' in navigator) {
			navigator.geolocation.getCurrentPosition(position => {
				let name = accessNested(props.appData, 'copy.$YOUR_LOCATION') || 'Your Location';
				Store.emit(actions.SET_CLIENT_GEO, new Geo({
					lat: position.coords.latitude,
					lon: position.coords.longitude,
					countryCode: props.client.geo.countryCode,
					city: name
				}), 'browsergeo');
			}, error => {
				console.log('Error getting user geolocation', error);
			});
		}
	}

	/**
	 * Event Handlers
	**/

	closeMap() {
		Store.emit(actions.SET_MAP_OPEN, false);
		track({ a: 'close_map' });
	}

	toggleVerticalStory = (verticalStoryEnabled) => {
		// return;
		const body = document.body;
		if (verticalStoryEnabled) {
			track({ a: 'vertical-mobile-banner-enable' });
			body.scrollTop = 0;
			body.style.overflow = 'hidden';
			body.style.position = 'fixed';
		} else {
			track({ a: 'vertical-mobile-close-experience' });
			body.style.overflow = '';
			body.style.position = '';
		}
		this.setState({ verticalStoryEnabled });
	}

	/**
	 * Renders
	**/

	getContentOutside() { }
	getContentAboveSelection() {}

	renderMap() {
		const {
			appData,
			client,
			pageData,
			showtimes,
		} = this.props;

		const {
			cities,
		} = showtimes;

		// Map not loaded yet
		let isMobile = client.deviceSize === 'mobile';

		const useMapTiler = !!accessNested(appData, 'apis.mapTiler.mapId');

		const breakTablet = parseInt(accessNested(appData, 'styling.variables.breakTablet'));
		const largeMobile = accessNested(client, 'dimensions.width') > breakTablet;

		if (isMobile && !showtimes.mapOpen && !this.mapLoaded) {
			return;
		}

		this.mapLoaded = true;
		let staticMapsObject = this.props.showtimes.staticMaps;
		let staticMap = (pageData.mapStaticPreview === undefined ? true : pageData.mapStaticPreview) && !isMobile;
		if (staticMapsObject.error) {
			staticMap = false;
		}
		const MapComponent = useMapTiler ? Maptiler : GMap;
		// const staticMap = false;
		let map = (
			<MapComponent
				ref={(ref) => this.$map = ref}
				pageData={pageData}
				useCustomMarker={pageData.customMapMarker}
				useDirections
				useMultipleDirections={pageData.useMultipleDirections}
				appData={appData}
				theaters={showtimes.theaters}
				activeTheater={this.activeTheater}
				cities={cities}
				center={client.geo}
				client={client}
				mapStyles={pageData.mapStyles}
				hideFilteredTheaters={pageData.hideFilteredTheaters}
				useStaticPreview={staticMap}
				staticMaps={staticMapsObject}
			/>
		);
		if (isMobile && !largeMobile) {
			return [
				map,
				<div onClick={this.closeMap} class={s.close}>
					<div class={s.icon} />
				</div>
			];
		}
		return map;
	}

	render(props) {
		const {
			activePage, // Object
			appData, // Object
			client, // Object
			showtimes, // Object
			id, // String
			sideNavActive, // Boolean
			pageData, // Object
			iosFixedFix, // Boolean
			header, // Object
			user,
		} = props;

		const {
			firstDataLoaded,
			error
		} = showtimes;

		const mapStyle = {};

		if (iosFixedFix) {
			mapStyle.position = 'absolute';
			mapStyle.marginTop = iosFixedFix + 'px';
		}

		const {
			isFirstVisit = true
		} = user;
		let {
			closableTrailer        = {},
			closingTrailer         = {}, //THIS HAS NOW BEEN DEPRECATED - remove if you see this still here after september 2018
			customDesktopUI        = false,
			trailerOverlayConstant = false,
			preventScrollToTheater = false
		} = pageData;

		//support 'closingTrailer' for now so that everything doesn't break - remove if you see this still here after september 2018
		closableTrailer = Object.keys(closableTrailer).length > 0 ? closableTrailer : closingTrailer;

		const {
			ytid            = '',
			closeText       = '',
			overlayText     = '',
			src: closingSrc = '',
			vimeoID         = '',
			showTT          = false
		} = closableTrailer;

		return (
			<div class={sideNavActive ? s.containerFull : s.container}>
				{(isFirstVisit || window.firstSessionVisit || trailerOverlayConstant) && (
					<ClosableTrailer
						src={closingSrc}
						ytid={ytid}
						vimeoID={vimeoID}
						src={closingSrc}
						closeText={closeText}
						overlayText={overlayText}
						showTT={showTT}
						imgRoot={accessNested(appData, 'urls.roots.imageRegion')}
						customDesktopUI={customDesktopUI}
						client={client}
						activePage={activePage}
					/>
				)}
				<OneSheet
					key="oneSheet"
					id={id}
					pageData={pageData}
					appData={appData}
					toggleVerticalStory={this.toggleVerticalStory}
					sideNavActive={sideNavActive}
					verticalFullView={client.deviceSize === 'mobile'}
					hideable={client.deviceSize != 'desktop'}
					forceClose={false && !!appData.options.showtimesVerticalStory}
					client={client}
					firstDataLoaded={firstDataLoaded || !!error}
					iosFixedFix={iosFixedFix}
				/>
				{this.getContentAboveSelection()}
				<Selection
					key="selection"
					showtimes={showtimes}
					appData={appData}
					client={client}
					fullScreen={sideNavActive}
					activePage={activePage}
					pageData={pageData}
					header={header}
					preventScrollToTheater={preventScrollToTheater}
				/>

				<div
					class={client.deviceSize === 'mobile' && showtimes.mapOpen ? s.mapOpen : s.map}
					ref={(mapWrap) => this.$mapWrap = mapWrap}
					style={mapStyle}
				>
					{this.renderMap()}
				</div>

				{client.deviceSize !== 'mobile' && !client.embedMode && (
					<FakeScrollbar
						realScrollContainer={typeof document !== 'undefined' && document.body}
						active
					/>
				)}
				<div class={s.contentOutside}>{this.getContentOutside()}</div>
			</div>
		);
	}

}

export const dependencies = {
	showtimes:  true,
	header:     true,
	client:     true,
	user:       true,
	activePage: true
};
